<template>
  <div id='home'>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
<style lang='scss'>
#home {
  // background: linear-gradient( rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0.75) ), url(/imgs/durham.jpg) no-repeat center center fixed;
  background-color: #15151a;
  background-position: center;
  background-repeat: no-repeat;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-image: url(/img/durham.jpg);
}
</style>
